<template>
    <div class="container">
        <label for="dataTable" class=" iot-station d-flex justify-content-start mt-3 mb-3 px-2">Destination</label>

        <div class="row px-3">
            <div class="mb-3">
                <table class="table table-hover table-responsive">
                    <thead class="table-light">
                        <tr>
                            <th scope="col" width="30">
                                <input class="form-check-input" type="checkbox" id="checkboxNoLabel" value=""
                                    aria-label="...">
                            </th>
                            <th scope="col" width="25">Filename</th>
                            <th scope="col" width="800">Repository</th>
                            <th scope="col" width="800">File Type</th>
                            <th scope="col" width="800">Month</th>
                            <th scope="col" width="800">Year</th>
                            <th scope="col" width="800">Hard Delete</th>
                            <th scope="col" width="800">Confirm Delete</th>
                            <th scope="col" >Restore</th>
                            <th></th>
                            <th ></th>
                            <!-- <th scope="col">
<span class="d-flex justify-content-end">
<tableHeadingIcon />
</span>

</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in destinationData" :key="index">
                            <td>
                                <div>
                                    <input class="form-check-input" type="checkbox" id="checkboxNoLabel" value=""
                                        aria-label="...">
                                </div>
                            </td>
                            <td>{{ item.filename }}</td>
                            <td>{{ item.repository }}</td>
                            <td>{{ item.filetype }}</td>
                            <td>{{ item.month }}</td>
                            <td>{{ item.year }}</td>
                            <td>
                                <button type="submit" class="btn btn-danger list-delete-button"
                                    :disabled="item.isharddelete === 0" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal3" @click="selectedDestHardDelItem = item">Delete</button>
                            </td>

                            <td>
                                <button type="submit" class="btn btn-danger list-delete-button"
                                    :disabled="item.isconfirmdelete === 0" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal4" @click="selectedDestConfDelItem = item">Delete</button>
                            </td>
                            <td>
              <svg @click="destFileRestore(item.repository, item.filename)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#1371E7" class="bi bi-arrow-counterclockwise" style="cursor: pointer;" viewBox="0 0 14 14">
  <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2z"/>
  <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466"/>
</svg>
            </td>
                            <td>
                                <div class="modal fade modal-sm" id="exampleModal3" tabindex="-1"
                                    aria-labelledby="exampleModal3Label" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h1 class="modal-title fs-5" id="exampleModal3Label"></h1>
                                                <button type="button" class="btn-close" data-bs-dismiss="modal"
                                                    aria-label="Close"></button>
                                            </div>
                                            <div class="modal-body">
                                                Are you sure you want to delete this record?
                                            </div>
                                            <div class="modal-footer">
                                                <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
                                                <button type="button" class="btn btn-danger btn-sm delete-button"
                                                    data-bs-dismiss="modal"
                                                    @click="destFileHardDelete(selectedDestHardDelItem.repository, selectedDestHardDelItem.filename)">Delete
                                                    Record</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </td>
                            <td>
                                <div class="modal fade modal-sm" id="exampleModal4" tabindex="-1"
                                    aria-labelledby="exampleModal4Label" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h1 class="modal-title fs-5" id="exampleModal4Label"></h1>
                                                <button type="button" class="btn-close" data-bs-dismiss="modal"
                                                    aria-label="Close"></button>
                                            </div>
                                            <div class="modal-body">
                                                Are you sure you want to delete this record?
                                            </div>
                                            <div class="modal-footer">
                                                <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
                                                <button type="button" class="btn btn-danger btn-sm delete-button"
                                                    data-bs-dismiss="modal"
                                                    @click="destFileConfirmDelete(selectedDestConfDelItem.repository, selectedDestConfDelItem.filename)">Delete
                                                    Record</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </td>

                            <!-- <td>
<router-link :to="`/iotassets/assettype/edit/${item.uuid}`">
<span class="d-flex justify-content-end">
  <editIcon />
</span>
</router-link>

</td> -->
                        </tr>

                    </tbody>
                </table>
                <div class="pagination-container">
                    <div class="items-per-page">
                        <label for="itemsPerPage">Records Per Page:</label>
                        <select id="itemsPerPage" class="items-per-page-dropdown" v-model="pageSize"
                            @change="changePageSize">
                            <option v-for="option in pageSizeOptions" :value="option">{{ option }}</option>
                        </select>
                    </div>
                    <div class="total-entries">
                        <span>Total Records: {{ totalCount }}</span>
                    </div>
                    <div class="pagination">
                        <ul class="pagination-list">
                            <li @click="gotoPage(1)"><a><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                                        fill="currentColor" class="bi bi-skip-start-fill" viewBox="0 0 16 16">
                                        <path
                                            d="M4 4a.5.5 0 0 1 1 0v3.248l6.267-3.636c.54-.313 1.232.066 1.232.696v7.384c0 .63-.692 1.01-1.232.697L5 8.753V12a.5.5 0 0 1-1 0z" />
                                    </svg></a></li>
                            <li @click="prevPage()"><a><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                        fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd"
                                            d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
                                    </svg></a></li>
                            <li v-for="pageNumber in visiblePages" :key="pageNumber"
                                :class="{ active: pageNumber === currentPage }" class="ellipsis-icon"
                                @click="gotoPage(pageNumber)">
                                <template v-if="pageNumber === 'dots'">
                                    <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            fill="currentColor" class="bi bi-three-dots" viewBox="0 0 16 16">
                                            <path
                                                d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3" />
                                        </svg>
                                    </span>
                                </template>
                                <template v-else>
                                    <a>{{ pageNumber }}</a>
                                </template>
                            </li>

                            <li @click="nextPage()"><a><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                        fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd"
                                            d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                                    </svg></a></li>
                            <li @click="gotoPage(totalPages)"><a><svg xmlns="http://www.w3.org/2000/svg" width="22"
                                        height="22" fill="currentColor" class="bi bi-skip-end-fill" viewBox="0 0 16 16">
                                        <path
                                            d="M12.5 4a.5.5 0 0 0-1 0v3.248L5.233 3.612C4.693 3.3 4 3.678 4 4.308v7.384c0 .63.692 1.01 1.233.697L11.5 8.753V12a.5.5 0 0 0 1 0z" />
                                    </svg></a></li>
                        </ul>
                    </div>
                </div>

            </div>
            <!-- <div class="col-md-12 d-flex justify-content-end" >
<div class="form-group ">
<button type="button" class="btn btn-danger btn-sm delete-button"
>Delete</button>
</div>
</div> -->
        </div>

    </div>
</template>
<script>
import Header from '@/components/Header.vue';
import Filter from '@/components/Filter.vue';
import { getTrashScanDestination, hardDelete, confirmDelete ,fileRestore} from "@/http/archival/trash-scan.http"
export default {
    name: "trash-scan",
    components: {
        Header,
        Filter,
    },
    data() {
        return {
            breadcrumsfirst: "Archival",
            breadcrumslast: "Trash Scan",
            selectedDestHardDelItem: null,
            selectedDestConfDelItem: null,
            filterConfig: {
                buttonConfig: {
                    show: false,
                    link: ''
                }
            },
            currentPage: 1,
            pageSize: 5,
            totalCount: 0,
            destinationData: [],
            pageSizeOptions: [5, 10, 20], // Define your options for items per page
        };
    },
    computed: {
        totalPages() {
            return Math.ceil(this.totalCount / this.pageSize);
        },
        visiblePages() {
            const totalVisiblePages = 3; // Change this as needed
            const pages = [];
            let startPage = 1;
            let endPage = this.totalPages;

            if (this.totalPages > totalVisiblePages) {
                const halfVisiblePages = Math.floor(totalVisiblePages / 2);
                startPage = Math.max(this.currentPage - halfVisiblePages, 1);
                endPage = startPage + totalVisiblePages - 1;

                if (endPage > this.totalPages) {
                    startPage -= endPage - this.totalPages;
                    endPage = this.totalPages;
                }

                if (startPage > 1) {
                    pages.push(1);
                    if (startPage > 2) {
                        pages.push('dots');
                    }
                }
            }

            for (let i = startPage; i <= endPage; i++) {
                pages.push(i);
            }

            if (endPage < this.totalPages) {
                if (endPage < this.totalPages - 1) {
                    pages.push('dots');
                }
                pages.push(this.totalPages);
            }

            return pages;
        }
    },
    methods: {
        destFetchData() {
            getTrashScanDestination({
                index: this.currentPage,
                pagesize: this.pageSize
            })
                .then(response => {
                    if (!response || response.length === 0) {
                        this.destinationData = [];
                        this.totalCount = 0
                    } else {
                        this.destinationData = response.data;
                        this.totalCount = response.recordcount.totalcount;
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        },

        destFileHardDelete(repository, filename) {

            const payload = {
                filename: `${repository}/${filename}`
            };

            hardDelete(payload).then(() => {
                this.destFetchData()
            }).catch(error => {
                console.error('Error disabling file:', error);
            });
        },
        destFileConfirmDelete(repository, filename) {

            const payload = {
                filename: `${repository}/${filename}`
            };

            confirmDelete(payload).then(() => {
                this.destFetchData()
            }).catch(error => {
                console.error('Error disabling file:', error);
            });
        },
        destFileRestore(repository, filename) {

const payload = {
  type: "dest",
  filename: `${repository}/${filename}`
};

fileRestore(payload).then(() => {
    this.currentPage = 1;
  this.destFetchData()
}).catch(error => {
  console.error('Error disabling file:', error);
});
},
        gotoPage(pageNumber) {
            if (pageNumber >= 1 && pageNumber <= this.totalPages) {
                this.currentPage = pageNumber;
                this.destFetchData();
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.destFetchData();
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
                this.destFetchData();
            }
        },
        changePageSize() {
            this.currentPage = 1; // Reset to the first page when changing page size
            this.destFetchData();
        }
    },
    mounted() {
        this.destFetchData();
    }
}
</script>